/**
 * Lokalizované popisy CRM communication ticket events (zdieľané activity + events panel).
 */

export function eventUserLabel(row) {
  const u = row?.user;
  if (u && typeof u === 'object') {
    return u.employee?.name || u.username || '';
  }
  return '';
}

/**
 * @param {(key: string) => string} t
 * @param {string} type
 * @param {string} [ticketType]
 */
export function resolveCrmCommunicationEventLabel(t, type, ticketType = '') {
  const baseKey = `CrmCommunication.Event.${type}`;
  if (ticketType && (type === 'semaphore.state_changed' || type === 'inspection.state_changed')) {
    const typedKey = `${baseKey}.${ticketType}`;
    const typedLabel = t(typedKey);
    if (typedLabel && typedLabel !== typedKey) {
      return typedLabel;
    }
  }
  const label = t(baseKey);
  return label && label !== baseKey ? label : type;
}
